export enum ImageSource {
    brandLogo = './images/logo-sj-header.png'
}



// WEBPACK FOOTER //
// ./src/models/image-source.ts